import {intersection} from "lodash";
import {ParentRouter} from "../services/ParentRouter";

import {
    catNipNav,
    dontShowNav, rolesNav,
    userNav,
    howToVideosNav,
} from "./nav";

export const mainNav = [
    ...dontShowNav,
    ...userNav,
    ...rolesNav,
    ...catNipNav,
    ...howToVideosNav,
]

class MyLinks extends ParentRouter
{
    #link = {}

    addLink({key, url, label, ...rest}){
        if (key && url && label){
            if (!this.#link.hasOwnProperty(key)){
                return this.#link = {
                    ...this.#link,
                    [key]: {
                        key,
                        url,
                        label,
                        ...rest,
                    }
                }
            }

            throw new Error(`Ключ у роута должен быть уникальным ${key}`)
        }

        throw new Error(`Укажите все параметры`)
    }

    getLink(key, query = {}){
        return this.buildQuery({...this.#findLink(key)}, query, '\\[.*?\\]')
    }

    getUlr(key, query = {}){
        return this.buildQuery({...this.#findLink(key)}, query, '\\[.*?\\]').url
    }

    getByUrl(url){
        return Object.values(this.#link).find((link) => link.url === url)
    }

    #findLink(key){
        if (this.#link.hasOwnProperty(key)){
            return this.#link[key]
        }

        throw new Error(`Роут не найден key = ${key}`)
    }
}

export const myLinks = new MyLinks()

mainNav.map((item)=>{
    myLinks.addLink(item)
})

export const userHasPermissions = (menuPermissions, userPermissions) =>{
    if (menuPermissions.length){
        return !!intersection(menuPermissions, userPermissions).length
    }
    return true
}

export const userHasRoles = (roles, userRole) =>{
    if (roles.length){
        return !!intersection(roles, userRole).length
    }
    return false
}

export const isShowLinkInNavBar = (menu, user) =>{

    return menu && !!(userHasPermissions(menu.permissions, user.permissions) && userShowLink(menu, user));
}

const userShowLink = (menu, user) =>{

    switch (menu.key) {
        default:
            return true
    }
}